import app from "./app";
import border from "./border";
import breadcrumbList from "./breadcrumbList";
import customLogo from "./customLogo";
import mobileNavToggle from "./mobileNavToggle";
import modeButton from "./modeButton";
import siteNav from "./siteNav";
import userNav from "./userNav";

export default `
  ${breadcrumbList}
  ${customLogo}
  ${border}
  ${app}
  ${mobileNavToggle}
  ${modeButton}
  ${siteNav}
  ${userNav}
`;
